import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from 'src/app/app.material.module';
import { SliderComponent } from './slider.component';

@NgModule({
  declarations: [SliderComponent],
  imports: [MaterialModule, CommonModule],
  exports: [SliderComponent] // Export the component so it can be used in other modules
})
export class SliderModule {}
